import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SelectedFilters = {
    name: string;
    values: string[];
}[];

export type PortfolioGeneralUIState = {
    selectedFilters: SelectedFilters;
};

const initialState: PortfolioGeneralUIState = {
    selectedFilters: [],
};

const portfolioGeneralSlice = createSlice({
    name: 'portfolioGeneral',
    initialState,
    reducers: {
        updateUiState: (state, action: PayloadAction<Partial<PortfolioGeneralUIState>>) => {
            return { ...state, ...action.payload };
        },
        updatePortfolioFilters: (state, action: PayloadAction<SelectedFilters>) => {
            state.selectedFilters = action.payload;
        },
        resetPortfolioFilters: state => {
            state.selectedFilters = [];
        },
    },
});

export const { updateUiState, updatePortfolioFilters, resetPortfolioFilters } = portfolioGeneralSlice.actions;

export default portfolioGeneralSlice.reducer;
